"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IUint8MatrixFromJS = exports.IUint8Matrix = void 0;
var immutable_1 = require("../../immutable");
exports.IUint8Matrix = (0, immutable_1.IRecord)({
    width: 0,
    height: 0,
    data: new Uint8Array()
});
var IUint8MatrixFromJS = function (Uint8MatrixJS) {
    return (0, exports.IUint8Matrix)({
        width: Uint8MatrixJS.width,
        height: Uint8MatrixJS.height,
        data: new Uint8Array(Uint8MatrixJS.data)
    });
};
exports.IUint8MatrixFromJS = IUint8MatrixFromJS;
